import styled from "styled-components";
import Link from "antd/es/typography/Link";

export const StyledAuth = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 50px;
    padding-top: 160px;
    background-color: rgba(251, 247, 240, 1);
`

export const StyledLink = styled(Link)`
    color: orange !important;
    margin-bottom: 8px !important;
`;
